import React, { useState, useEffect } from 'react';
// import styles from "./Features.scss";
import styles from './NewPropertyWizard.scss';
import { IStep } from './NewPropertySteps';
import Check from '../Check';

export interface IFeaturesProps {
    step: IStep;
    data: { features: string[] };
    onChange: (name: string, value: boolean) => void;
}

const Features: React.FC<React.PropsWithChildren<IFeaturesProps>> = ({ data = null, step = null, onChange = () => {} }) => {
    const [nextData, setNextData] = useState(data); // for showing internal state without rerendering complete parent component

    useEffect(() => {
        setNextData(data);
    }, [data]);

    return (
        <ul className={styles.features}>
            {Object.keys(step.features)
                .sort((a, b) => step.features[a].localeCompare(step.features[b]))
                .map((key) => {
                    const title = step.features[key];
                    const isChecked = !!nextData.features.find((f) => f === key);
                    return (
                        <li
                            key={key}
                            className={styles.feature + (isChecked ? ' ' + styles.active : '')}
                            onClick={() => {
                                const value = !isChecked;
                                const nextFeatures = nextData;
                                nextFeatures.features = nextFeatures.features.filter((f) => f !== key);
                                if (value) {
                                    nextFeatures.features.push(key);
                                }
                                setNextData({ ...nextFeatures });
                                onChange(key, value);
                            }}
                        >
                            <Check checked={isChecked} />
                            <span>{title}</span>
                        </li>
                    );
                })}
        </ul>
    );
};

export default Features;
